import http from '../http';

export const getProjectForHome = (selectedCompanyId: string) =>
  http.get(`home/projects`, {
    params: selectedCompanyId ? { companyId: selectedCompanyId } : {}
  });

export const getUpdateReports = () => {
  return http.get(`home/reports`);
};

export const getNotiForHome = () => {
  return http.get(`home/notifications`);
};

export const getInquiriesForHome = (companyId: number) => {
  return http.get(`home/inquiries`, { params: companyId ? { companyId } : {} });
};

interface Office {
  address: string;
}

export interface Project {
  id: string;
  projectStatus: string;
  office: Office;
  companyName?: string;
  projectTitle: string;
  memo: string;
}

export interface Report {
  date: string;
  content: string;
}

export interface Notification {
  importance: string;
  content: string;
  date: string;
  subject: string;
}

export interface Inquire {
  importance: string;
  id: string;
  companyName?: string;
  officeForHome: Office;
  subject: string;
  content: string;
  status: number;
}

export const getProjects = async (selectedCompanyId: string) => {
  const dataSourceProject: Record<string, any>[] = [];
  const projects = (await getProjectForHome(selectedCompanyId)) as Project[];

  for (let i = 0; i < projects.length; i++) {
    dataSourceProject.push({
      status: projects[i].projectStatus,
      projectId: projects[i].id,
      companyName: projects[i].company.name,
      title: projects[i].projectTitle,
      memo: projects[i].memo
    });
  }

  return dataSourceProject;
};

export const getInquire = async (selectedCompanyId: number) => {
  const dataSourceInquire: Record<string, any>[] = [];
  const inquire = (await getInquiriesForHome(Number(selectedCompanyId))) as Inquire[];

  for (let i = 0; i < inquire.length; i++) {
    dataSourceInquire.push({
      importance: inquire[i].importance,
      id: inquire[i].id,
      companyName: inquire[i].companyName,
      subject: inquire[i].subject,
      content: inquire[i].content,
      status: inquire[i].status
    });
  }

  return dataSourceInquire;
};

export const customEllipsis = (record: any, rowIndex: number, column: any) => {
  return {
    title:''
  };
};

export const formatDate = (date: string) => {
  const d = new Date(date);

  // Kiểm tra nếu giá trị ngày không hợp lệ
  if (isNaN(d.getTime())) {
    return 'Invalid date';
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Thêm 1 vì getMonth() trả về 0-11
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
};
export const getProjColumn = (t: any) => [
  { title: t('status'), dataIndex: 'status', key: 'p_status', width: 60, align: 'center' },
  { title: t('project_id'), dataIndex: 'projectId', key: 'project_id', width: 60, align: 'center' },
  {
    title: t('company_name'),
    dataIndex: 'companyName',
    key: 'company_name',
    width: 200,
    align: 'left',
    ellipsis: true,
    customHeaderCell: () => {
      return { style: { textAlign: 'center' }, title: '' };
    },
    customCell: customEllipsis
  },
  {
    title: t('project_title'),
    dataIndex: 'title',
    key: 'project_title',
    width: 300,
    align: 'left',
    ellipsis: true,
    customHeaderCell: () => {
      return { style: { textAlign: 'center' }, title: '' };
    },
    customCell: customEllipsis
  },
  { title: t('note'), dataIndex: 'memo', key: 'p_memo', width: 50, align: 'center' }
];

export const getInquireColumn = (t: any) => [
  {
    title: t('importance'),
    dataIndex: 'importance',
    key: 'importance',
    width: 50,
    align: 'center'
  },
  {
    title: t('inquiry_id'),
    dataIndex: 'id',
    align: 'center',
    key: 'id',
    width: 100
  },
  {
    title: t('company_name'),
    dataIndex: 'companyName',
    key: 'companyName',
    width: 200,
    align: 'left',
    ellipsis: true,
    customHeaderCell: () => {
      return { style: { textAlign: 'center' }, title: '' };
    },
    customCell: customEllipsis
  },
  {
    title: t('subject'),
    dataIndex: 'subject',
    key: 'subject',
    width: 300,
    align: 'left',
    ellipsis: true,
    customHeaderCell: () => {
      return { style: { textAlign: 'center' }, title: '' };
    },
    customCell: customEllipsis
  },
  { title: t('content'), dataIndex: 'content', key: 'content', width: 50, align: 'center' },
  { title: t('status'), dataIndex: 'status', key: 'status', width: 100, align: 'center' }
];

export const changeEllipsis = (event: any, type: string) => {
  const target = event.target;
  const normalTextCondition = type === 'notoce' ? target.scrollHeight >= target.clientHeight : target.scrollHeight > target.clientHeight;
  if (normalTextCondition && target.classList.contains('ellipsis')) {
    target.classList.remove('ellipsis');
    target.classList.add('normal-text');
  } else {
    target.classList.remove('normal-text');
    target.classList.add('ellipsis');
  }
};

export const handleHover = (event: any) => {
  const target = event.target;
  if ((target.scrollHeight <= target.clientHeight) && target.scrollHeight !== 0 && target.clientHeight !== 0 ) {
    target.classList.add('no-ellipsis');
  } else {
    target.classList.remove('no-ellipsis');
  }
};


export const getImportantClass = (important: String) => {
  switch (important) {
    case 'MOST_IMPORTANT':
      return 'red';
    case 'IMPORTANT':
      return 'yellow';
    case 'SLIGHTLY_IMPORTANT':
      return 'blue';
    default:
      return '';
  }
};
